module.exports = __webpack_public_path__ + "img/CIO314_1-1.4db9e042.jpg";